/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * AirwallexApi - axios parameter creator
 * @export
 */
export const AirwallexApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Post a request to Airwallex to create a beneficiary @body createBeneficiaryDto
         * @param {CreateBeneficiaryDto} createBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerCreateBeneficiary: (createBeneficiaryDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBeneficiaryDto' is not null or undefined
            assertParamExists('airwallexControllerCreateBeneficiary', 'createBeneficiaryDto', createBeneficiaryDto);
            const localVarPath = `/airwallex/beneficiary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBeneficiaryDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerDeleteBeneficiary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('airwallexControllerDeleteBeneficiary', 'id', id);
            const localVarPath = `/airwallex/beneficiary/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get auth code for use by the embedded beneficiary form
         * @param {string} codeChallenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetAuthCode: (codeChallenge, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'codeChallenge' is not null or undefined
            assertParamExists('airwallexControllerGetAuthCode', 'codeChallenge', codeChallenge);
            const localVarPath = `/airwallex/auth-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (codeChallenge !== undefined) {
                localVarQueryParameter['codeChallenge'] = codeChallenge;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerGetBeneficiary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('airwallexControllerGetBeneficiary', 'id', id);
            const localVarPath = `/airwallex/beneficiary/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get current balance from Airwallex @query AirwallexCurrentBalanceParamsDto
         * @param {Array<string>} currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetCurrentBalances: (currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('airwallexControllerGetCurrentBalances', 'currency', currency);
            const localVarPath = `/airwallex/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (currency) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get form schema and validation requirements from Airwallex
         * @param {AirwallexAccountTypeEnum} accountType
         * @param {string} accountCurrency
         * @param {string} bankCountry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerSchema: (accountType, accountCurrency, bankCountry, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountType' is not null or undefined
            assertParamExists('airwallexControllerSchema', 'accountType', accountType);
            // verify required parameter 'accountCurrency' is not null or undefined
            assertParamExists('airwallexControllerSchema', 'accountCurrency', accountCurrency);
            // verify required parameter 'bankCountry' is not null or undefined
            assertParamExists('airwallexControllerSchema', 'bankCountry', bankCountry);
            const localVarPath = `/airwallex/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountType !== undefined) {
                localVarQueryParameter['accountType'] = accountType;
            }
            if (accountCurrency !== undefined) {
                localVarQueryParameter['accountCurrency'] = accountCurrency;
            }
            if (bankCountry !== undefined) {
                localVarQueryParameter['bankCountry'] = bankCountry;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a beneficiary by Id
         * @param {string} id
         * @param {UpdateBeneficiaryDto} updateBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerUpdateBeneficiary: (id, updateBeneficiaryDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('airwallexControllerUpdateBeneficiary', 'id', id);
            // verify required parameter 'updateBeneficiaryDto' is not null or undefined
            assertParamExists('airwallexControllerUpdateBeneficiary', 'updateBeneficiaryDto', updateBeneficiaryDto);
            const localVarPath = `/airwallex/beneficiary/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBeneficiaryDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AirwallexApi - functional programming interface
 * @export
 */
export const AirwallexApiFp = function (configuration) {
    const localVarAxiosParamCreator = AirwallexApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Post a request to Airwallex to create a beneficiary @body createBeneficiaryDto
         * @param {CreateBeneficiaryDto} createBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerCreateBeneficiary(createBeneficiaryDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerCreateBeneficiary(createBeneficiaryDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerDeleteBeneficiary(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerDeleteBeneficiary(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get auth code for use by the embedded beneficiary form
         * @param {string} codeChallenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetAuthCode(codeChallenge, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerGetAuthCode(codeChallenge, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerGetBeneficiary(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerGetBeneficiary(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get current balance from Airwallex @query AirwallexCurrentBalanceParamsDto
         * @param {Array<string>} currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetCurrentBalances(currency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerGetCurrentBalances(currency, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get form schema and validation requirements from Airwallex
         * @param {AirwallexAccountTypeEnum} accountType
         * @param {string} accountCurrency
         * @param {string} bankCountry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerSchema(accountType, accountCurrency, bankCountry, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerSchema(accountType, accountCurrency, bankCountry, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a beneficiary by Id
         * @param {string} id
         * @param {UpdateBeneficiaryDto} updateBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AirwallexApi - factory interface
 * @export
 */
export const AirwallexApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AirwallexApiFp(configuration);
    return {
        /**
         *
         * @summary Post a request to Airwallex to create a beneficiary @body createBeneficiaryDto
         * @param {CreateBeneficiaryDto} createBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerCreateBeneficiary(createBeneficiaryDto, options) {
            return localVarFp
                .airwallexControllerCreateBeneficiary(createBeneficiaryDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerDeleteBeneficiary(id, options) {
            return localVarFp
                .airwallexControllerDeleteBeneficiary(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get auth code for use by the embedded beneficiary form
         * @param {string} codeChallenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetAuthCode(codeChallenge, options) {
            return localVarFp
                .airwallexControllerGetAuthCode(codeChallenge, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get beneficiary by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerGetBeneficiary(id, options) {
            return localVarFp
                .airwallexControllerGetBeneficiary(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get current balance from Airwallex @query AirwallexCurrentBalanceParamsDto
         * @param {Array<string>} currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerGetCurrentBalances(currency, options) {
            return localVarFp
                .airwallexControllerGetCurrentBalances(currency, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get form schema and validation requirements from Airwallex
         * @param {AirwallexAccountTypeEnum} accountType
         * @param {string} accountCurrency
         * @param {string} bankCountry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airwallexControllerSchema(accountType, accountCurrency, bankCountry, options) {
            return localVarFp
                .airwallexControllerSchema(accountType, accountCurrency, bankCountry, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a beneficiary by Id
         * @param {string} id
         * @param {UpdateBeneficiaryDto} updateBeneficiaryDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options) {
            return localVarFp
                .airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AirwallexApi - object-oriented interface
 * @export
 * @class AirwallexApi
 * @extends {BaseAPI}
 */
export class AirwallexApi extends BaseAPI {
    /**
     *
     * @summary Post a request to Airwallex to create a beneficiary @body createBeneficiaryDto
     * @param {CreateBeneficiaryDto} createBeneficiaryDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerCreateBeneficiary(createBeneficiaryDto, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerCreateBeneficiary(createBeneficiaryDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a beneficiary by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerDeleteBeneficiary(id, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerDeleteBeneficiary(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get auth code for use by the embedded beneficiary form
     * @param {string} codeChallenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerGetAuthCode(codeChallenge, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerGetAuthCode(codeChallenge, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get beneficiary by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerGetBeneficiary(id, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerGetBeneficiary(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get current balance from Airwallex @query AirwallexCurrentBalanceParamsDto
     * @param {Array<string>} currency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerGetCurrentBalances(currency, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerGetCurrentBalances(currency, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get form schema and validation requirements from Airwallex
     * @param {AirwallexAccountTypeEnum} accountType
     * @param {string} accountCurrency
     * @param {string} bankCountry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerSchema(accountType, accountCurrency, bankCountry, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerSchema(accountType, accountCurrency, bankCountry, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a beneficiary by Id
     * @param {string} id
     * @param {UpdateBeneficiaryDto} updateBeneficiaryDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AirwallexApi
     */
    airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options) {
        return AirwallexApiFp(this.configuration)
            .airwallexControllerUpdateBeneficiary(id, updateBeneficiaryDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
